import React from "react"
import { FormControl, InputLabel, Select as MuiSelect, MenuItem } from "@material-ui/core"

export type SelectOption = { value: string; label: string }

export type SelectProps = {
	options: SelectOption[]
	value: string
	onChange: (value: string) => void
	placeholder?: string
	label?: string
}

export const Select: React.FC<SelectProps> = ({ options, value, onChange, placeholder, label }) => {
	const labelId = label ? `select-label-${label.replace(/\s/g, "-")}` : undefined

	return (
		<FormControl variant="outlined" fullWidth size="small">
			{label && <InputLabel id={labelId}>{label}</InputLabel>}
			<MuiSelect
				labelId={labelId}
				value={value}
				onChange={(event) => onChange(event.target.value as string)}
				label={label}
				displayEmpty={!label}
			>
				{placeholder && (
					<MenuItem value="" disabled>
						<em>{placeholder}</em>
					</MenuItem>
				)}
				{options.map((option) => (
					<MenuItem key={option.value} value={option.value}>
						{option.label}
					</MenuItem>
				))}
			</MuiSelect>
		</FormControl>
	)
}
